function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#c9ddea;}.cls-3{fill:#b1b1b1;}.cls-4{fill:#8d8f8f;}.cls-5{fill:#eaf6fe;}.cls-6{fill:#e2e5f6;}.cls-7{fill:#fff;}.cls-8{fill:#aeb0b0;}.cls-9{fill:#6a99de;}.cls-10{fill:#d4ecff;}.cls-11{fill:#c9515b;}.cls-12{fill:#233954;}.cls-13{fill:#405068;}.cls-14{fill:#0b3e8a;}.cls-15{fill:#edbc9c;}.cls-16{fill:#dd9f80;}.cls-17{fill:none;}.cls-18{fill:#81c4ef;}.cls-19{fill:#60b1e6;}.cls-20{fill:#2c3949;}.cls-21{fill:#8c9caf;}.cls-22{fill:#6e7a89;}.cls-23{fill:#5c87c7;}.cls-23,.cls-25{opacity:0.56;}.cls-24{fill:#d9d9d9;}.cls-25{fill:#435e91;}.cls-26{fill:#983f46;opacity:0.29;mix-blend-mode:multiply;}.cls-27{fill:#db7d37;}.cls-28{fill:#afddfd;}.cls-29{fill:#e6f5ff;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\u0420\u0435\u0441\u0443\u0440\u0441 3");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_2",
  "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "OBJECTS"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M342.07,138.47c8.39,0,8.85-12.62.47-13l-.69,0a14,14,0,0,0-4.29.67,14.39,14.39,0,0,0-28.47.45,13.32,13.32,0,0,0-9-.88c-7.33,1.89-5.8,12.8,1.78,12.8Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 188.71,
  cy: 282.04,
  rx: 188.71,
  ry: 11.8
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 125.26,
  cy: 283.96,
  rx: 33.25,
  ry: 2.37
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 82.05,
  y: 112.96,
  width: 226.05,
  height: 160.63,
  rx: 7.96,
  ry: 7.96
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 118.79,
  y: 104.07,
  width: 139.84,
  height: 178.4,
  rx: 1.48,
  ry: 1.48,
  transform: "translate(381.98 4.57) rotate(90)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M276.58,123.35H100.84a1.33,1.33,0,0,0-1.33,1.33v3.81H270.41a1.33,1.33,0,0,1,1.33,1.33V263.2h4.84a1.33,1.33,0,0,0,1.33-1.33V124.69A1.33,1.33,0,0,0,276.58,123.35Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 292.85,
  cy: 193.28,
  r: 7.27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M100.84,263.2h94.55c-5.29,3.87-9.42,7.35-15.28,10.39H89.2A7.15,7.15,0,0,1,82,266.44V120.11A7.15,7.15,0,0,1,89.2,113H242.26q1.89,5.1,3.34,10.39H100.84a1.33,1.33,0,0,0-1.34,1.34V261.87A1.33,1.33,0,0,0,100.84,263.2Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 135.95,
  width: 1.71,
  height: 83.25
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 258.28,
  width: 1.71,
  height: 102.37
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 139.79,
  y: 63.23,
  width: 101.44,
  height: 147.5,
  rx: 9.88,
  ry: 9.88,
  transform: "translate(32.37 310.32) rotate(-83.34)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M267.56,113l.94-8a9.88,9.88,0,0,0-8.67-11L133,79.19a9.88,9.88,0,0,0-11,8.67l-.94,8Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 133.38,
  cy: 90.09,
  r: 2.66,
  transform: "translate(28.43 212.12) rotate(-83.34)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 146.1,
  cy: 91.58,
  r: 2.66,
  transform: "translate(38.2 226.08) rotate(-83.34)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 159.29,
  cy: 93.12,
  r: 2.66,
  transform: "translate(48.33 240.54) rotate(-83.34)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M138.5,146.44l18.32-31.92,8.54,1-4.09,33.65,3.7.45-.87,7.11-3.7-.45-1.1,9-7.68-.93,1.1-9-15.08-1.83Zm15.08,1.83,2.28-18.71-10.17,17.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M177.36,129.14c1-8,5.72-12,13.4-11.08s11.33,6,10.36,14L198,157.93c-1,8-5.72,12-13.4,11.08s-11.33-6-10.36-14ZM182,156.49c-.43,3.56,1,5.1,3.46,5.4s4.22-.86,4.65-4.42l3.27-26.89c.43-3.56-1-5.1-3.46-5.4s-4.22.86-4.65,4.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M208.51,155,226.84,123l8.54,1-4.09,33.65,3.7.45-.87,7.11-3.7-.45-1.1,9-7.68-.93,1.1-9-15.08-1.83Zm15.08,1.83,2.28-18.71L215.7,155.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M110.89,212.06a68.27,68.27,0,0,0-1.43,15.37c.26,7-.57,52.67-.57,52.67h5.58s7.95-35.81,8.25-38.63,4.3-31.1,4.3-31.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M114.61,210a120,120,0,0,0,3.47,16.71C120.26,233.63,131,280.1,131,280.1h5.58s-1-35.81-1.41-38.63-3.21-31.1-3.21-31.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M131.46,280.09V284h10.63a.61.61,0,0,0,.34-1.12,16.85,16.85,0,0,0-6.36-2.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M109.18,280.09V284h10.63a.61.61,0,0,0,.34-1.12,16.85,16.85,0,0,0-6.36-2.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M129.48,159.3h0l0,0-.14-.16-.19-.18-.18-.12a2.26,2.26,0,0,0-.31-.15l-.19-.08a3.46,3.46,0,0,0-.64-.14c-3.22-.42-4.55.54-4.55.54s-3.71-.41-5.74,1.35c-1.39,1.21-6.5,10.56,1.76,13.95l.73.28.22.07.45.14.25.06.37.09.25,0,.32.05.24,0,.29,0h.48l.21,0,.23,0,.19,0,.2-.05.17-.06.18-.07.16-.08.16-.09.14-.09.14-.11.13-.11.12-.12.11-.12.1-.13.1-.14.08-.13.09-.15.06-.12a8.12,8.12,0,0,0,.36-4.4l2.57-4.47S130.68,161,129.48,159.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M123.21,167.25s-1.08-1.08-1.9,0-.27,3.52,1.08,3.66c0,0-.41,3.52-3.11,3.39v2.84h6.36V175s3.93-1.62,3.79-4.87a18,18,0,0,0-1.08-5.55A8.85,8.85,0,0,1,123.21,167.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M124.19,175.88c.63.26.52.66.55,1.26h.92V175a5.11,5.11,0,0,1-3.8-.8A10,10,0,0,0,124.19,175.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M125.49,162.07s-3.3-1.31-3.68-.33c-.25.64.39,1.2,1.27,1.76l-.78.13a.2.2,0,0,0-.1.36,4.37,4.37,0,0,0,2.06.34Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-17",
  points: "105.87 197.84 110.29 212.08 110.21 211.37 110.29 212.08 111.78 191.34 105.87 197.84"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M149,170.33c-6.29-4.66-23.47-8.39-23.47-8.39l-1.42,2.58s15.6,6,14.57,6.94c-.6.53-8.23,4-10.81,5.2a4.1,4.1,0,0,1-1.77.36l-7.9,0a12.46,12.46,0,0,0-10.18,4.47c-4,4.61-10.82,15.29-10.82,15.29l11.47,16.87,1.27,1.86v.13l1.13.11c3.69.34,15.51,1.28,21.76-.05l.17,0-.3-27.68A107.28,107.28,0,0,0,149.23,172,1.16,1.16,0,0,0,149,170.33Zm-38.49,37.74-1.12-2.45-3.56-7.79,5.91-6.63-1.06,14.54Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-19",
  points: "109.43 205.63 110.55 208.07 110.01 215.46 110 215.48 108.72 213.61 109.43 205.63"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M130.1,187c-1.06.77-.79,7.62-1.06,11.9-.44,7.17-.87,13.37-.55,17.37a31.91,31.91,0,0,0,4.4-.55l.17,0-.3-27.68A107.28,107.28,0,0,0,149.23,172a1.16,1.16,0,0,0-.18-1.7A141,141,0,0,1,130.1,187Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M135.17,241.47c-.28-2-1.83-17.33-2.67-25.69l-4,.44s5.85,48.13,6.24,63.88h1.86S135.56,244.3,135.17,241.47Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M71.36,266.55s-1.72-1.61-.57-7.71,4.09-12,2.65-18.57S60.73,217,60.69,215.88s-3.48,19.4,2.35,27.49,6.53,10.88,6.27,15.13.06,7.67.7,8.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M70.29,254.29c-.68,2.72-1.09,9.54,0,11.17.1.15.25.07.43-.22a14,14,0,0,1,.08-6.4c1.15-6.1,4.09-12,2.65-18.57S60.73,217,60.69,215.88c0,0,1.7,13.9,7.42,23.46A18.26,18.26,0,0,1,70.29,254.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M73.41,266.13s-3.31-8.27,2.3-15.43,14.59-16.35,14.77-20c0,0,2.31,17.29-5,22.18s-12.43,5.67-11.16,13.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M81.3,249.42c-8.15,5.93-8.81,12.76-7.55,15.93a.81.81,0,0,0,.53.48c-1.09-7.27,4-8.09,11.2-12.93s5-22.18,5-22.18S89.44,243.49,81.3,249.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M68,266.32a28.91,28.91,0,0,0,.5-9.1c-.57-4.73-5.5-7.39-10.12-12.38-2.37-2.57-3.08-16.15-1.6-17.41,0,0-8.14,9.87-6.89,17.1s14.54,11.92,15.77,15.42a19.39,19.39,0,0,1,1.13,6.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M54,231.31c-2.69,7.29.07,16.12,9,21.6,6.58,4,4.49,12.43,4.49,12.43L68.56,262a26.25,26.25,0,0,0-.1-4.82c-.57-4.73-5.5-7.39-10.12-12.38-2.29-2.48-3-15.2-1.75-17.23A43.6,43.6,0,0,0,54,231.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M56.59,227.6l.15-.18A.81.81,0,0,0,56.59,227.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M75.11,265.77s1.91-7.08,6.63-8,10.14-7.93,10.44-9.3C92.18,248.43,91.39,261.59,75.11,265.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M81.48,260.07A7.83,7.83,0,0,0,77,265.23c14.49-4.66,15.23-16.8,15.23-16.8a5.19,5.19,0,0,1-.74,1.38C90,252.31,86.59,257.52,81.48,260.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M85.33,263.16H60.64l2.93,18.44A2.88,2.88,0,0,0,66.42,284H79.55a2.88,2.88,0,0,0,2.85-2.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M79.35,263.16H60.64l.49,3.05H78.86L76.42,281.6A2.88,2.88,0,0,1,73.57,284h6a2.88,2.88,0,0,0,2.84-2.43l2.93-18.44Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 150.72,
  y: 230.27,
  width: 111.61,
  height: 22.69
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-26",
  x: 150.72,
  y: 230.27,
  width: 111.61,
  height: 5.51
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "160.43 230.27 170.61 230.27 167.88 235.78 157.69 235.78 160.43 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "183.38 230.27 193.56 230.27 190.83 235.78 180.65 235.78 183.38 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "206.32 230.27 216.51 230.27 213.78 235.78 203.59 235.78 206.32 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "229.27 230.27 239.46 230.27 236.72 235.78 226.54 235.78 229.27 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-27",
  points: "262.33 230.27 262.33 230.42 259.67 235.78 249.49 235.78 252.22 230.27 262.33 230.27"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 164.61,
  y: 252.96,
  width: 7.87,
  height: 31.03
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 241.18,
  y: 252.96,
  width: 7.87,
  height: 31.03
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 164.61,
  y: 226.72,
  width: 7.87,
  height: 3.52
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 241.18,
  y: 226.72,
  width: 7.87,
  height: 3.52
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "164.61 256.85 170.69 256.85 170.69 283.99 172.48 283.99 172.48 256.85 172.48 252.96 172.48 252.94 164.61 252.94 164.61 256.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "241.18 256.85 246.72 256.85 246.72 283.99 249.05 283.99 249.05 256.85 249.05 252.96 249.05 252.94 241.18 252.94 241.18 256.85"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "170.69 229.81 164.61 229.81 164.61 230.25 172.48 230.25 172.48 230.25 172.48 229.81 172.48 226.72 170.69 226.72 170.69 229.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-23",
  points: "246.72 226.72 246.72 229.81 241.18 229.81 241.18 230.25 249.05 230.25 249.05 230.25 249.05 229.81 249.05 226.72 246.72 226.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "170.61 230.27 159.36 252.96 150.72 252.96 150.72 249.83 160.43 230.27 170.61 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "183.38 230.27 172.12 252.96 182.31 252.96 193.56 230.27 183.38 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "216.51 230.27 205.25 252.96 195.07 252.96 206.32 230.27 216.51 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "239.46 230.27 228.21 252.96 218.02 252.96 229.27 230.27 239.46 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "252.22 230.27 240.97 252.96 251.15 252.96 262.33 230.42 252.22 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "170.61 230.27 167.88 235.78 157.69 235.78 160.43 230.27 170.61 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "193.56 230.27 190.83 235.78 180.65 235.78 183.38 230.27 193.56 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "216.51 230.27 213.78 235.78 203.59 235.78 206.32 230.27 216.51 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "239.46 230.27 236.72 235.78 226.54 235.78 229.27 230.27 239.46 230.27"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "262.33 230.42 259.67 235.78 249.49 235.78 252.22 230.27 262.33 230.42"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 168.34,
  cy: 221.8,
  r: 7.01
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 168.34,
  cy: 221.8,
  r: 3.18
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 245.07,
  cy: 221.8,
  r: 7.01
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 245.07,
  cy: 221.8,
  r: 3.18
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M304.61,281.59H269.07l5.44-13.18h0l2.19-5.32.6-1.46,1-2.37.2-.48,2.19-5.32.4-1,3.88-9.41a2.06,2.06,0,0,1,3.8,0l3.88,9.41.4,1,2.19,5.32.2.48,1,2.37.6,1.46,2.19,5.32h0Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-26",
  points: "271.4 275.93 269.07 281.58 304.61 281.58 302.28 275.93 271.4 275.93"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-28",
  x: 266.23,
  y: 278.21,
  width: 40.71,
  height: 5.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-23",
  x: 298.14,
  y: 278.21,
  width: 8.8,
  height: 5.76
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M303.21,278.2h-5l-4-9.8h0L292,263.08l-.6-1.46-1-2.37-.2-.48L288,253.45l-.4-1-3.26-7.92.61-1.49a2.06,2.06,0,0,1,3.8,0l3.88,9.41.4,1,2.19,5.32.2.48,1,2.37.6,1.46,2.19,5.32h0Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "295.2 258.77 278.47 258.77 280.66 253.45 293.01 253.45 295.2 258.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "299.17 268.4 299.17 268.41 274.5 268.41 274.5 268.4 276.69 263.08 296.99 263.08 299.17 268.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "295.2 258.77 290.17 258.77 287.99 253.45 293.01 253.45 295.2 258.77"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-29",
  points: "299.17 268.4 299.17 268.41 294.14 268.41 294.14 268.4 291.96 263.08 296.99 263.08 299.17 268.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M230.46,62c8.39,0,8.85-12.62.47-13l-.69,0a14,14,0,0,0-4.29.67,14.39,14.39,0,0,0-28.46.45,13.32,13.32,0,0,0-9-.88c-7.33,1.89-5.79,12.8,1.78,12.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M89.87,102.37a5.34,5.34,0,0,0,5.32-4.56A10.61,10.61,0,0,0,84.69,85.76l-.71,0a11.27,11.27,0,0,0-22.49,1c0,.28,0,.55,0,.82a11.27,11.27,0,0,0-16.73,9v.13a5.37,5.37,0,0,0,5.38,5.65Z"
}))));

var SvgNotFound = function SvgNotFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 377.42 293.84",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_found.3f854c25.svg";
export { ForwardRef as ReactComponent };